export default __webpack_public_path__ + "static/media/istanbul.b1da5073.png";